import React, { useState } from 'react';
import { 
  Mic, 
  ShieldAlert, 
  CheckCircle2, 
  AlertTriangle, 
  PhoneCall,
  Info
} from 'lucide-react';

export const DeepfakeAudioCheckerPage: React.FC = () => {
  const [questions, setQuestions] = useState({
    droppedNumber: true,
    askedForMoney: true,
    extremePanic: true,
    failedSafeWord: true
  });

  const riskScore = (Object.values(questions).filter(Boolean).length / 4) * 100;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-950 text-rose-300 text-xs font-bold border border-rose-800">
          <Mic className="w-3.5 h-3.5" />
          <span>AI SYNTHETIC VOICE & FAMILY EMERGENCY DIAGNOSTIC</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">AI Voice Clone & "Hi Mum" Emergency Call Assessor</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Evaluate whether an urgent phone call claiming a relative is in hospital or police custody is an AI-generated synthetic voice clone.
        </p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 space-y-6 shadow-xl text-xs">
        <h3 className="font-bold text-white text-sm uppercase tracking-wider">Answer Call Telemetry Indicators:</h3>

        <div className="space-y-3">
          <label className="flex items-center justify-between p-4 rounded-xl bg-slate-950 border border-slate-800 cursor-pointer">
            <span className="text-slate-200">1. Was the call made from an unknown or spoofed number rather than their saved contact?</span>
            <input
              type="checkbox"
              checked={questions.droppedNumber}
              onChange={(e) => setQuestions({ ...questions, droppedNumber: e.target.checked })}
              className="accent-rose-500 w-4 h-4"
            />
          </label>

          <label className="flex items-center justify-between p-4 rounded-xl bg-slate-950 border border-slate-800 cursor-pointer">
            <span className="text-slate-200">2. Did the caller demand urgent bank transfers, gift cards, or crypto for bail/repairs?</span>
            <input
              type="checkbox"
              checked={questions.askedForMoney}
              onChange={(e) => setQuestions({ ...questions, askedForMoney: e.target.checked })}
              className="accent-rose-500 w-4 h-4"
            />
          </label>

          <label className="flex items-center justify-between p-4 rounded-xl bg-slate-950 border border-slate-800 cursor-pointer">
            <span className="text-slate-200">3. Was the caller unable or unwilling to confirm an offline family secret safe-word?</span>
            <input
              type="checkbox"
              checked={questions.failedSafeWord}
              onChange={(e) => setQuestions({ ...questions, failedSafeWord: e.target.checked })}
              className="accent-rose-500 w-4 h-4"
            />
          </label>
        </div>

        <div className="p-6 rounded-2xl bg-rose-950/30 border border-rose-800 text-rose-200 space-y-2">
          <div className="flex items-center justify-between">
            <span className="font-bold text-white text-sm">Synthetic Voice Probability:</span>
            <span className="text-xl font-extrabold text-rose-400 font-mono">{riskScore}% HIGH PROBABILITY SCAM</span>
          </div>
          <p className="leading-relaxed">
            EMERGENCY PROTOCOL: Hang up immediately. Dial your family member directly on their known, original phone number or contact their spouse/school. Do not transfer funds.
          </p>
        </div>
      </div>
    </div>
  );
};
